<template>
  <div class="customer-filter">
    <a-row>
      <a-col :span="22">
        <a-form-model layout="inline" :form="filterForm" :model="filterForm">
          <a-form-model-item label="名称">
            <a-input v-model="filterForm.name" allow-clear placeholder="用例名称" class="form-model-item" style="width: 150px" @change="onSearch" />
          </a-form-model-item>
          <a-form-model-item label="评审结果">
            <a-select v-model="filterForm.result" mode="multiple" allow-clear placeholder="选择评审结果" style="width: 150px" @change="onSearch">
              <a-select-option v-for="(item, index) in reviewItemResults" :key="index" :value="item.value">
                <a-tag v-if="item.value !== 5" :color="item.color">{{ item.label }}</a-tag>
                <a-tag v-else :color="item.color" style="color: gray; width: 40px">{{ item.label }}</a-tag>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="用例目录">
            <a-input v-model="filterForm.module" allow-clear placeholder="目录:可从列表中点击复制" class="form-model-item" style="width: 210px" @change="onSearch" />
          </a-form-model-item>
        </a-form-model>
      </a-col>
      <a-col :span="2">
        <div style="margin-bottom: 10px; padding-right: 5px; float: right; margin-top: 3px">
          <a-button v-tc="{ name: '关联用例' }" type="primary" icon="plus" style="margin-right: 3px" @click="onAddCase()">关联用例 </a-button>
        </div>
      </a-col>
    </a-row>

    <a-table :scroll="{ x: 1300 }" :pagination="pagination" :columns="columns" :data-source="tableData" :loading="loading" row-key="id" :row-selection="showRowSelection" @change="handleTableChange">
      <span slot="name" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a class="custom-link" @click="onDetail(record)"> {{ record.name }} </a>
        </a-tooltip>
      </span>
      <span slot="id" slot-scope="text, record">
        <span>TC-{{ record.id }}</span>
      </span>
      <span slot="priority" slot-scope="text, record">
        <a-tag v-if="record.priority !== null && record.priority !== undefined" :color="casePrioritys[record.priority].color"> {{ casePrioritys[record.priority].label }} </a-tag>
        <span v-else>--</span>
      </span>
      <span slot="result" slot-scope="text, record">
        <review-case-result-edit :disabled="resultDisabled" :review-id="reviewId" :case-id="record.id" :result="record.result" @change="getCaseList" />
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag v-if="record.status" :color="caseStatus[record.status].color"> {{ caseStatus[record.status].label }} </a-tag>
        <span v-else>--</span>
      </span>
      <span slot="tags" slot-scope="text, record">
        <a-popover placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
          <template slot="title">
            <span>用例标签</span>
          </template>
          <template v-if="record.tags.length > 1">
            <a-tag v-for="(tag, index) in record.tags.slice(0, 1)" :key="index" color="blue">{{ tag.name }}</a-tag>
            ...
          </template>
          <template v-else>
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
        </a-popover>
      </span>
      <span slot="reviewer" slot-scope="text, record">{{ record.reviewer ? record.reviewer.nickname : '--' }}</span>
      <span slot="reviewTime" slot-scope="text, record">
        {{ record.review_time !== '' ? record.review_time : '--' }}
      </span>
      <span slot="progress" slot-scope="text, record">
        <a-progress :percent="record.progress" size="small" style="width: 120px" />
      </span>
      <span slot="path" slot-scope="text, record">
        <span style="cursor: pointer" @click="onCopy(record)">
          <template v-if="record.path.path_str">
            <template v-if="record.path.path_str.length < 13">{{ record.path.path_str }}</template>
            <template v-else>
              <a-popover placement="topLeft">
                <template slot="content">{{ record.path.path_str }}</template>
                {{ record.path.path_str.slice(0, 13) }}...
              </a-popover>
            </template>
          </template>
          <span v-else>未分配</span>
        </span>
      </span>
    </a-table>
    <review-case-editable-detail :display="detailVisible" :review-id="reviewId" :has-next="hasNext" :has-before="hasBefore" :case-id="caseId" @close="close" @next="loadNextCase" @before="loadBeforeCase" />
  </div>
</template>

<script>
import { reviewRelatedCases } from '@/api/project/review';
import { caseStatus, casePrioritys, reviewItemResults } from '@/utils/dictionary';

import ReviewCaseResultEdit from '@/pages/project/review/components/ReviewCaseResultEdit';
import ReviewCaseEditableDetail from '@/pages/project/review/components/ReviewCaseEditableDetail';

const columns = [
  {
    key: 'selection-column',
    align: 'center',
    width: 20
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'key',
    width: 80,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'id' }
  },
  {
    title: '名称',
    dataIndex: 'name',
    width: 250,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '目录',
    dataIndex: 'module_id',
    width: 200,
    sorter: true,
    scopedSlots: { customRender: 'path' }
  },
  {
    title: '优先级',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '标签',
    width: 100,
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '评审结果',
    dataIndex: 'result',
    width: 80,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'result' }
  },
  // {
  //   title: '评审进度',
  //   width: 170,
  //   align: 'center',
  //   dataIndex: 'progress',
  //   scopedSlots: {customRender: 'progress'}
  // },
  {
    title: '评审人员',
    width: 120,
    align: 'center',
    dataIndex: 'reviewer',
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'reviewer' }
  },
  {
    title: '评审时间',
    width: 170,
    align: 'center',
    dataIndex: 'review_time',
    scopedSlots: { customRender: 'reviewTime' }
  }
];
export default {
  name: 'ReviewCaseList',
  components: { ReviewCaseResultEdit, ReviewCaseEditableDetail },
  props: {
    reviewId: {
      type: [Number, String],
      default: null
    },
    resultDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePrioritys,
      reviewItemResults,
      tester: null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      caseData: {},
      loading: false,
      detailVisible: false,
      caseId: null,
      projectId: parseInt(this.$route.params.project_id) || null,
      nextCaseId: null,
      hasNext: false,
      beforeCaseId: null,
      hasBefore: false,
      selectedRowKeys: [],
      filterForm: {
        name: '',
        tester: [],
        result: []
      },
      sorter: {
        sort_field: null,
        sort: null
      },
      assignCaseModalVisible: false
    };
  },
  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    },
    showRowSelection() {
      return { selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange };
    }
  },
  watch: {
    planId: {
      immediate: true,
      handler(val) {
        if (val != null) {
          // eslint-disable-next-line vue/no-mutating-props
          this.reviewId = val;
          this.getCaseList();
        }
      }
    }
  },
  created() {
    this.getCaseList();
  },
  methods: {
    onAddCase() {
      this.$emit('add-case');
    },
    onCopy(record) {
      const oInput = document.createElement('input');
      if (record.path.path_str) {
        oInput.value = record.path.path_str;
      } else {
        oInput.value = '未分配';
      }
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.remove();
      this.$message.success('复制成功');
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    testerChange(val) {
      this.tester = val;
    },
    onSearch() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getCaseList();
    },
    // 查看用例详情
    onDetail(record) {
      this.caseId = record.id;
      this.detailVisible = true;
      this.caseData = record;
      this.findNextCase();
      this.findBeforeCase();
    },
    findNextCase() {
      const index = this.tableData.findIndex(row => row.id === this.caseId);
      if (index !== this.tableData.length - 1) {
        this.nextCaseId = this.tableData[index + 1].id;
        this.hasNext = true;
      } else {
        if (!this.hasNextPage()) {
          this.nextCaseId = null;
          this.hasNext = false;
        } else {
          this.nextCaseId = -1;
          this.hasNext = true;
        }
      }
    },
    findBeforeCase() {
      const index = this.tableData.findIndex(row => row.id === this.caseId);
      if (index !== 0 && index < this.tableData.length) {
        this.beforeCaseId = this.tableData[index - 1].id;
        this.hasBefore = true;
      } else {
        if (!this.hasBeforePage()) {
          this.beforeCaseId = null;
          this.hasBefore = false;
        } else {
          this.beforeCaseId = -1;
          this.hasBefore = true;
        }
      }
    },
    hasNextPage() {
      const pageNumber = this.pagination.current;
      const total = this.pagination.total;
      if (pageNumber * this.pagination.pageSize < total) {
        return true;
      }
      return false;
    },
    hasBeforePage() {
      const pageNumber = this.pagination.current;
      if (pageNumber > 1) {
        return true;
      }
      return false;
    },
    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.sorter.sort_field = sorter.field;
      this.sorter.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getCaseList();
    },
    close() {
      this.caseId = null;
      this.caseData = {};
      this.detailVisible = false;
      this.getCaseList();
      // this.$emit('refresh')
    },
    // 获取用例列表
    getCaseList() {
      this.loading = true;
      reviewRelatedCases({
        ...this.filterForm,
        ...this.sorter,
        result: this.filterForm.result.length > 0 ? this.filterForm.result : null,
        project_id: this.projectId,
        review_id: this.reviewId,
        page_number: this.pagination.current,
        page_size: this.pagination.pageSize
      })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCaseListPromise() {
      return reviewRelatedCases({
        ...this.filterForm,
        ...this.sorter,
        tester: this.filterForm.tester.length > 0 ? this.filterForm.tester : null,
        result: this.filterForm.result.length > 0 ? this.filterForm.result : null,
        project_id: this.projectId,
        review_id: this.reviewId,
        page_number: this.pagination.current,
        page_size: this.pagination.pageSize
      });
    },
    loadNextCase() {
      if (this.nextCaseId != null) {
        if (this.nextCaseId !== -1) {
          this.caseId = this.nextCaseId;
          this.findNextCase();
          this.findBeforeCase();
        } else {
          this.pagination.current += 1;
          if (this.pagination.current > Math.ceil(this.pagination.total / this.pagination.pageSize)) {
            return;
          }
          this.getCaseListPromise().then(res => {
            this.tableData = res.data.items;
            if (this.tableData.length > 0) {
              this.caseId = this.tableData[0].id;
            }
            this.findNextCase();
            this.findBeforeCase();
          });
        }
      }
    },
    loadBeforeCase() {
      if (this.beforeCaseId != null) {
        if (this.beforeCaseId !== -1) {
          this.caseId = this.beforeCaseId;
          this.findNextCase();
          this.findBeforeCase();
        } else {
          this.pagination.current -= 1;
          this.getCaseListPromise().then(res => {
            this.tableData = res.data.items;
            if (this.tableData.length > 0) {
              this.caseId = this.tableData[this.tableData.length - 1].id;
            }
            this.findNextCase();
            this.findBeforeCase();
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  .ant-form-item {
    margin-bottom: 8px;
    display: inline-block !important;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }

  .customer-date-picker {
    width: calc(50% - 3px);
  }
}

/deep/ .ant-table-tbody > tr > td {
  padding: 8px 8px;
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px 8px;
}

.handle-menu {
  margin: 0 4px;
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.handle-button {
  margin-left: 8px;
}
</style>
